
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire18e5"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire18e5"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("27Lyk", function(module, exports) {

$parcel$export(module.exports, "register", () => $18c11f3350a906ea$export$6503ec6e8aabbaf, (v) => $18c11f3350a906ea$export$6503ec6e8aabbaf = v);
$parcel$export(module.exports, "resolve", () => $18c11f3350a906ea$export$f7ad0328861e2f03, (v) => $18c11f3350a906ea$export$f7ad0328861e2f03 = v);
var $18c11f3350a906ea$export$6503ec6e8aabbaf;
var $18c11f3350a906ea$export$f7ad0328861e2f03;
"use strict";
var $18c11f3350a906ea$var$mapping = new Map();
function $18c11f3350a906ea$var$register(baseUrl, manifest) {
    for(var i = 0; i < manifest.length - 1; i += 2)$18c11f3350a906ea$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $18c11f3350a906ea$var$resolve(id) {
    var resolved = $18c11f3350a906ea$var$mapping.get(id);
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$18c11f3350a906ea$export$6503ec6e8aabbaf = $18c11f3350a906ea$var$register;
$18c11f3350a906ea$export$f7ad0328861e2f03 = $18c11f3350a906ea$var$resolve;

});

parcelRegister("iIuFd", function(module, exports) {

$parcel$export(module.exports, "default", () => $da041f39a5c80e7c$export$2e2bcd8739ae039);
$parcel$export(module.exports, "getRetryMessage", () => $da041f39a5c80e7c$export$aeb83d7b2bf1c0e7);
const $da041f39a5c80e7c$var$DEFAULT_MESSAGE = "Looks like you are offline. Please check your internet connection, and try again later.";
function $da041f39a5c80e7c$export$2e2bcd8739ae039(message = $da041f39a5c80e7c$var$DEFAULT_MESSAGE) {
    let offlineMsgDiv = document.createElement("div");
    // Styling lives in resets.css under .page-banner — there rather than in
    // either page sheet, because core/index.js raises this banner too. It used to be six inline style assignments here, which made
    // this the only component on the page that no stylesheet could reach.
    offlineMsgDiv.className = "page-banner";
    offlineMsgDiv.textContent = message;
    return offlineMsgDiv;
}
function $da041f39a5c80e7c$export$aeb83d7b2bf1c0e7(message) {
    const panel = $da041f39a5c80e7c$export$2e2bcd8739ae039(message);
    const retryBtn = document.createElement("button");
    retryBtn.textContent = "Try again";
    retryBtn.addEventListener("click", ()=>window.location.reload());
    panel.appendChild(document.createElement("br"));
    panel.appendChild(retryBtn);
    return panel;
}

});

parcelRegister("7eLLW", function(module, exports) {

$parcel$export(module.exports, "default", () => $544ee5ccb4c6c100$export$2e2bcd8739ae039);
// The single definition of "is this the real site".
//
// It lives in its own module, with no Firebase import, so the landing page can
// use it to gate the service worker without pulling the whole SDK into a bundle
// that is otherwise 3 KB. firebaseConfig.js imports it too — one definition, so
// the emulator gate and the service-worker gate cannot drift apart.
//
// Allowlisting production and defaulting everything else to "not production" is
// the safe direction: an unrecognised host gets the emulator and no service
// worker, both of which fail visibly rather than silently talking to live data.
const $544ee5ccb4c6c100$var$PRODUCTION_HOSTS = [
    "greatmahabharataquiz.com",
    "www.greatmahabharataquiz.com"
];
function $544ee5ccb4c6c100$export$2e2bcd8739ae039() {
    return $544ee5ccb4c6c100$var$PRODUCTION_HOSTS.includes(location.hostname) || location.hostname.endsWith(".netlify.app");
}

});

parcelRegister("7XY9T", function(module, exports) {
module.exports = new URL("sw.js", import.meta.url).toString();

});

parcelRegister("b0m9P", function(module, exports) {

$parcel$export(module.exports, "default", () => $8030e1d148821675$export$2e2bcd8739ae039);
// True when the page is running as an installed app rather than a browser tab.
//
// Two callers, for opposite reasons: the install banner hides itself here, and
// the sign-in wrapper switches to redirect here, because signInWithPopup cannot
// complete in a standalone window.
//
// display-mode: standalone covers Android and modern iOS. navigator.standalone
// is the older iOS-only flag, kept because iOS honoured it long before it
// supported the media query.
function $8030e1d148821675$export$2e2bcd8739ae039() {
    return window.matchMedia("(display-mode: standalone)").matches || window.matchMedia("(display-mode: fullscreen)").matches || window.matchMedia("(display-mode: minimal-ui)").matches || window.navigator.standalone === true;
}

});

var $806942703d136925$exports = {};

(parcelRequire("27Lyk")).register(new URL("", import.meta.url).toString(), JSON.parse('["d7fef","index.277498f3.js","czWhb","sw.js","4YRZe","play.091cc1e7.js"]'));


var $iIuFd = parcelRequire("iIuFd");

var $3mebY = parcelRequire("3mebY");

var $7eLLW = parcelRequire("7eLLW");

var $gVCw1 = parcelRequire("gVCw1");

// Production only. A worker registered against the Parcel dev server outlives
// it and then serves a fully cached app off a dead server, which looks like the
// dev server working and is miserable to diagnose. Same gate as the emulator.
//
// new URL(..., import.meta.url) is Parcel's supported form; a plain "/sw.js"
// string would not be bundled. Classic worker: sw.js imports nothing.
if ("serviceWorker" in navigator && (0, $7eLLW.default)()) navigator.serviceWorker.register((parcelRequire("7XY9T")));
(0, $3mebY.default)();
// The rank ladder section. Two jobs: fill the four wheels, then reveal the
// section once when it is scrolled to.
//
// The badges come from the same rankBadge() play.html uses, so the wheels here
// cannot drift from the ones the app draws or from the one printed on the
// certificate they add up to. That costs nothing this page cannot afford:
// rank.js and rankBadge.js import nothing but each other, so no Firebase
// reaches this bundle. Hand-pasted SVG in index.html would have been the same
// bytes with a silent drift attached, and nothing would ever have checked it.
//
// By NAME, read back off each <li>, not by index into RANKS. The two fail
// differently and only one of them fails visibly: indexing means inserting a
// rung in rank.js silently shifts every wheel one place down, so Ratha would
// wear Maharatha's wheel and look perfectly fine. rankBadge() validates the
// name against RANKS itself and returns "" for one it does not know, so the
// same edit leaves an empty box instead. A missing wheel is obviously broken;
// a wrong wheel is a lie. That lookup is also why RANKS is not imported here.
const $9c7831375d8cf03f$var$ladderSteps = document.querySelector(".ladder-steps");
if ($9c7831375d8cf03f$var$ladderSteps) {
    $9c7831375d8cf03f$var$ladderSteps.querySelectorAll("li").forEach((step)=>{
        const name = step.querySelector(".ladder-name")?.textContent.trim();
        // 48 is the wide-layout size; .ladder-badge sizes the svg to its own box in
        // CSS, so the attribute only decides what a reader with no stylesheet gets.
        step.querySelector(".ladder-badge").innerHTML = (0, $gVCw1.default)(name, 48);
    });
    // is-ready is what applies the from-state, and it is set HERE, beside the
    // observer that clears it. If this file never runs, or IntersectionObserver
    // is missing, the ladder is simply already finished. Nothing is ever left
    // hidden waiting for a script. See the motion note in styles/index.css.
    //
    // Only when the section starts BELOW THE FOLD. This runs after first paint,
    // so arming it on a ladder the reader can already see paints the finished
    // section, blanks it, and re-staggers it — which is what a browser restoring
    // a scroll position on reload does, and it reads as a glitch rather than as
    // a reveal. There is nothing to reveal to someone already looking at it.
    const belowFold = $9c7831375d8cf03f$var$ladderSteps.getBoundingClientRect().top > window.innerHeight;
    if (belowFold && "IntersectionObserver" in window) {
        $9c7831375d8cf03f$var$ladderSteps.classList.add("is-ready");
        new IntersectionObserver(([entry], observer)=>{
            if (!entry.isIntersecting) return;
            entry.target.classList.add("is-in");
            observer.disconnect(); // one-shot: it must not replay on scroll back
        }, {
            threshold: 0.35
        }).observe($9c7831375d8cf03f$var$ladderSteps);
    }
}
// The landing page is entirely static, so the service worker keeps it usable
// offline. Say so, rather than disabling it.
function $9c7831375d8cf03f$var$showOfflineBanner() {
    if (document.getElementById("offlineMessage")) return;
    let body = document.querySelector("body");
    const offlineMsgDiv = (0, $iIuFd.default)("You are offline. You can still open the quiz and play any questions you have downloaded.");
    offlineMsgDiv.id = "offlineMessage";
    body.insertBefore(offlineMsgDiv, body.firstChild);
}
window.addEventListener("offline", $9c7831375d8cf03f$var$showOfflineBanner);
window.addEventListener("online", ()=>{
    document.getElementById("offlineMessage")?.remove();
});
// A page opened while already offline never fires the "offline" event.
if (!navigator.onLine) $9c7831375d8cf03f$var$showOfflineBanner();


//# sourceMappingURL=index.277498f3.js.map
